import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { MdDashboard } from "react-icons/md";
import { FaUser, FaMoneyCheck, FaTicketAlt } from "react-icons/fa";
import { HiMegaphone } from "react-icons/hi2";
import { IoCalendar, IoSettings } from "react-icons/io5";
import { SiGoogletasks, SiReadthedocs } from "react-icons/si";
import { IoMdInformationCircle } from "react-icons/io";
import { BiSolidCoinStack } from "react-icons/bi";
import { Sidebar } from "flowbite-react";
import {
  hasRole,
  CAN_ACCESS_ASSETS,
  CAN_ACCESS_HR,
  CAN_ACCESS_PAYROLL,
  CAN_ACCESS_SYSDEV,
  CAN_ACCESS_TICKETING_ADMIN,
  SUPER_ADMINS,
} from "../config/roles";

// Sidebar sections that are temporarily hidden. The role/position checks below
// are left untouched — flip a value back to true to restore that entry.
const SHOW_IN_SIDEBAR = {
  systemDev: false,
  payroll: false,
  departments: false,
};

const SidebarComponent = ({ isSidebarOpen, toggleSidebar }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { logout, user, role, position, firstName } = useAuth();
  const navigate = useNavigate();

  // A link is only shown when the matching route guard would actually let the
  // user through — see src/config/roles.js and src/config/routes.js.
  const canSeeSysDev = hasRole(role, CAN_ACCESS_SYSDEV);
  const canSeeAssets = hasRole(role, CAN_ACCESS_ASSETS);
  const canSeeTicketing = hasRole(role, CAN_ACCESS_TICKETING_ADMIN);
  const canSeePayroll = hasRole(role, CAN_ACCESS_PAYROLL);
  const canSeeHR = hasRole(role, CAN_ACCESS_HR);
  const isSuperAdmin = hasRole(role, SUPER_ADMINS);

  const handleLinkClick = (path) => {
    navigate(path);
    toggleSidebar();
    setIsDropdownOpen(false);
  };

  return (
    <div className="h-full bg-white dark:bg-gray-800 border-gray-700">
      <Sidebar
        open={isSidebarOpen}
        className=''
        onClose={toggleSidebar}
        aria-label="Sidebar with content separator example"
        style={{ borderColor: "rgba(0, 0, 0, 0.25)" }}
        theme={{
          "root": {
            "base": "h-full",
            "collapsed": {
              "on": "w-16",
              "off": "w-64"
            },
            "inner": "h-full overflow-y-auto overflow-x-hidden bg-white dark:bg-gray-800 px-3 py-4"
          }
        }}
      >
        <Sidebar.Items>
          <Sidebar.ItemGroup>
            <Sidebar.Item className="pt-5" icon={MdDashboard} onClick={() => handleLinkClick('/user/dashboard')}>
              Dashboard
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={FaUser} onClick={() => handleLinkClick('/user/profile')}>
              Profile
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={HiMegaphone} onClick={() => handleLinkClick('/user/announcements')}>
              Announcements
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('/user/attendance-monitoring')}>
              Attendance
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={SiGoogletasks} onClick={() => handleLinkClick('/user/todo')}>
              To Do
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={SiReadthedocs} onClick={() => handleLinkClick('/user/resources')}>
              Resources
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={FaTicketAlt} onClick={() => handleLinkClick('/ticketing/my-tickets')}>
              Support Tickets
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={IoSettings} onClick={() => handleLinkClick('/user/settings')}>
              Settings
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={IoMdInformationCircle} onClick={() => handleLinkClick('/user/about')}>
              About
            </Sidebar.Item>
          </Sidebar.ItemGroup>

          <Sidebar.ItemGroup>
          {SHOW_IN_SIDEBAR.systemDev && canSeeSysDev && (
              <Sidebar.Item className="pt-5" icon={BiSolidCoinStack} onClick={() => handleLinkClick('/sysdev/dashboard')}>
                System Dev
              </Sidebar.Item>
            )}
            {canSeeAssets && (
              <Sidebar.Item className="pt-5" icon={BiSolidCoinStack} onClick={() => handleLinkClick('/assets/dashboard')}>
                Inventory System
              </Sidebar.Item>
            )}
            {canSeeTicketing && (
              <Sidebar.Item className="pt-5" icon={FaTicketAlt} onClick={() => handleLinkClick('/ticketing/dashboard')}>
                Ticketing System
              </Sidebar.Item>
            )}
            {SHOW_IN_SIDEBAR.payroll && canSeePayroll && (
              <Sidebar.Item className="pt-5" icon={FaMoneyCheck} onClick={() => handleLinkClick('/payroll/payroll-employees')}>
                Payroll Management
              </Sidebar.Item>
            )}
            {canSeeHR && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('/hr/hr-dashboard')}>
                HR Management
              </Sidebar.Item>
            )}
             {SHOW_IN_SIDEBAR.departments && (position === 'Finance & Admin Manager/CFO' || isSuperAdmin) && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('/department')}>
                Subic - FAD
              </Sidebar.Item>
            )}
            {SHOW_IN_SIDEBAR.departments && (position === 'Sales Manager' || isSuperAdmin) && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('/department')}>
                Subic - Sales
              </Sidebar.Item>
            )}
            {SHOW_IN_SIDEBAR.departments && (position === 'Manila - Branch Manager' || isSuperAdmin) && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('/department')}>
                Manila
              </Sidebar.Item>
            )}
            {SHOW_IN_SIDEBAR.departments && (position === 'Cebu - Branch Manager' || isSuperAdmin) && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('/department')}>
                Cebu
              </Sidebar.Item>
            )}
            {SHOW_IN_SIDEBAR.departments && (position === 'Southern Region Manager' || isSuperAdmin) && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('/department')}>
                Davao
              </Sidebar.Item>
            )}
              {SHOW_IN_SIDEBAR.departments && (firstName === 'Rolan Jayson' || isSuperAdmin) && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('/department')}>
                Palawan
              </Sidebar.Item>
            )}

          </Sidebar.ItemGroup>

        </Sidebar.Items>
      </Sidebar>
    </div>
  );
};

export default SidebarComponent;
